/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { forEach, groupBy } from 'lodash';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  detailReportTypeTableGrid,
  summaryReportTypeTableGrid,
  summaryReportTypeTableGridWithOutQtr,
} from './TableHead';
import {
  getNdcGrid,
  getUnitConversionDetail,
} from '../../../Maintain/unitConversion/store/actions';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getClaimTableInfo,
  navigateToClaim,
} from '../../../Display/Claim/store/action';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from './PaginationBox';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getDetailReportTypeQtrList,
  getSummaryReportTypeQtrList,
  getDetailReportTypeNdcList,
  getSummaryReportTypeMfgList,
  setPaginationIndex,
  getExportToAllData,
  setExportToAllData,
} from '../Store/Action';
import { getCurrentQtr } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  MNFC_NDC_ERROR_MSG,
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';
import { exportAllPDF } from './ExportAll';

const DisplayHcpcsCode = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const getIsAllMfg = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.isMfgChecked
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const {
    displayObj: {
      selectedOption: getSelectedOptionList,
      sortBy: getSortBy,
      startQtr: startQtrValue,
      endQtr: endQtrValue,
      rebateProgramName,
      rebateProgrameName,
      allManufacturer: manufactureName,
      detailQtrSearchData: resultDetailQtrList,
      detailNdcSearchData: resultDetailNdcList,
      summaryQtrSearchData: resultSummaryQtrList,
      summaryMfgSearchData: resultSummaryMfgList,
      manufactureWithIds: manufactureID,
      countValue,
    },
  } = useSelector((state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer);
  // TO get the complete name of the rebate program
  const rebateProgramNameValue = `${rebateProgrameName?.rebateProgramCd} - ${
    rebateProgrameName?.shortDescr || ''
  }`;
  const exportAllData = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.exportToAllList
  );
  const isLoading = useSelector(
    (state) => state?.sharedState?.HcpcsCodeClaimsPaidReducer?.isLoading
  );

  const [DetailQtrList, setDetailQtrList] = React.useState([]);
  const [DetailNdcList, setDetailNdcList] = React.useState([]);
  const [summaryMfgList, setSummaryMfgList] = React.useState();
  const [curQtr, setCurQtr] = React.useState(getCurrentQtr().join('Q'));
  const [summaryQtrList, setSummaryQtrList] = React.useState();
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filteredRows1, setFilteredRow1] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [exportFileName, setExportFileName] = React.useState(null);
  const [columnApi, setColumnApi] = React.useState(null);

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const paginationLength =
    getSelectedOptionList === 'Detail' ? manufactureID?.length : 1;
  const [count, setCount] = React.useState(countValue);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(paginationLength).keys(),
  ]);

  const rowData1 = getSortBy == 'NDC' ? DetailNdcList : DetailQtrList;
  const rowData2 =
    getSortBy == 'Manufacturer' ? summaryMfgList : summaryQtrList;

  React.useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    setErrorMessages([]);
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }
    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }
    if (type === 'change') {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  const handleBlur = (value) => {
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   dispatch(setPaginationIndex(0));
    //   setTimeout(() => {
    //     value < 1
    //       ? dispatch(setPaginationIndex(1))
    //       : dispatch(setPaginationIndex(paginationArray.length));
    //   }, 20);
    // } else {
    setErrorMessages([]);
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };

  // mfg grid api
  const manufacturer = manufactureID?.[count - 1]?.manufacturerID;

  function convertDateFormat(dateStr) {
    const year = dateStr?.substr(2);
    const quarter = dateStr?.substr(0, 1);
    const convertedStr = year + quarter;
    return convertedStr;
  }
  const newStartQtr = convertDateFormat(startQtrValue);
  const newEndQtr = convertDateFormat(endQtrValue);
  const nCurQtr = convertDateFormat(curQtr);

  // detail Quarter type from API
  React.useEffect(() => {
    const newData = resultDetailQtrList?.map((item) => {
      const percent_medical =
        item.total_units === 0
          ? 0
          : 100 * (Number(item.jcode_units) / Number(item.total_units));

      const newQtr = `${item.paid_qtr?.substring(
        4,
        5
      )}Q${item.paid_qtr?.substring(0, 4)}`;

      const newInvAmt = parseFloat(item.ura) * parseFloat(item.jcode_units);
      return {
        ...item,
        paid_qtr: newQtr,
        percent_medical: parseFloat(percent_medical)?.toFixed(2),
        inv_amt: newInvAmt?.toFixed(2),
      };
    });
    setDetailQtrList(newData);
  }, [resultDetailQtrList]);

  React.useEffect(() => {
    if (
      getSelectedOptionList === 'Detail' &&
      getSortBy === 'Quarter' &&
      manufacturer != null
    ) {
      dispatch(
        getDetailReportTypeQtrList({
          asRpc: rebateProgramName,
          asStartQtr: newStartQtr,
          asEndQtr: newEndQtr || nCurQtr,
          asMfg: [manufacturer],
          // an_all: getIsAllMfg == true ? 1 : 0,
          an_all: 0,
          an_allclaim: 1,
        })
      );
    }
  }, [count, manufactureID]);

  React.useEffect(() => {
    const paginationLength =
      getSelectedOptionList === 'Detail' ? manufactureID?.length : 1;
    setPaginationArray([...Array(paginationLength).keys()]);
  }, [manufactureID]);

  // detail  NDC type from API
  React.useEffect(() => {
    const newData = resultDetailNdcList?.map((item) => {
      const percent_medical =
        item.total_units === 0
          ? 0
          : 100 * (Number(item.jcode_units) / Number(item.total_units));

      const newQtr = `${item.paid_qtr?.substring(
        4,
        5
      )}Q${item.paid_qtr?.substring(0, 4)}`;
      const newInvAmt = item.ura * item.total_units;
      return {
        ...item,
        paid_qtr: newQtr,
        percent_medical: parseFloat(percent_medical)?.toFixed(2),
        inv_amt: newInvAmt ? newInvAmt?.toFixed(2) : '0.000',
        jcodereimb_amt: item.jcodereimb_amt
          ? parseFloat(item.jcodereimb_amt).toFixed(2)
          : '0.00',
        total_paid_amt: item.total_paid_amt
          ? parseFloat(item.total_paid_amt).toFixed(2)
          : '0.00',
      };
    });
    setDetailNdcList(newData);
  }, [resultDetailNdcList]);

  React.useEffect(() => {
    if (
      getSelectedOptionList === 'Detail' &&
      getSortBy === 'NDC' &&
      manufacturer &&
      manufacturer !== null
    ) {
      dispatch(
        getDetailReportTypeNdcList({
          asRpc: rebateProgramName,
          asStartQtr: newStartQtr,
          asEndQtr: newEndQtr || nCurQtr,
          asMfg: [manufacturer],
          // an_all: getIsAllMfg == true ? 1 : 0,
          an_all: 0,
          an_allclaim: 1,
        })
      );
    }
  }, [count, manufactureID]);
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  // summary Quarter type from API
  React.useEffect(() => {
    setSummaryQtrList(resultSummaryQtrList);
  }, [resultSummaryQtrList]);

  React.useEffect(() => {
    if (getSelectedOptionList === 'Summary' && getSortBy === 'Quarter') {
      dispatch(
        getSummaryReportTypeQtrList({
          asRpc: rebateProgramName,
          asStartQtr: newStartQtr,
          asEndQtr: newEndQtr || nCurQtr,
          asMfg: [manufacturer],
          // an_all: 1,
          an_all: getIsAllMfg == true ? 1 : 0,
          an_allclaim: 1,
        })
      );
    }
  }, []);

  // summary manufacturing type from API
  React.useEffect(() => {
    setSummaryMfgList(resultSummaryMfgList);
  }, [resultSummaryMfgList]);

  React.useEffect(() => {
    if (getSelectedOptionList === 'Summary' && getSortBy === 'Manufacturer') {
      dispatch(
        getSummaryReportTypeMfgList({
          asRpc: rebateProgramName,
          asStartQtr: newStartQtr,
          asEndQtr: newEndQtr || nCurQtr,
          asMfg: [manufacturer],
          // an_all: 1,
          an_all: getIsAllMfg == true ? 1 : 0,
          an_allclaim: 1,
        })
      );
    }
  }, []);

  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rowData1;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        action: '',
        ura: '',
        total_units: 'Grand Total:',
        percent_medical: '',
        jcodereimb_amt: sum('jcodereimb_amt'),
        inv_amt: sum('inv_amt'),
        total_paid_amt: sum('total_paid_amt'),
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rowData1]);

  // filter the data from row
  const onFilterChanged = (rowData1, type) => {
    const updatedRowData = rowData1.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // Total for summary table

 const sum1 = (property) => {
  const rows1 = Array.isArray(filteredRows1) ? filteredRows1 : [];
  const rows2 = Array.isArray(rowData2) ? rowData2 : [];
  let displayedRows1 = rows1.length > 0 ? rows1 : rows2;
  displayedRows1 = displayedRows1.filter(row => row.labeler_name !== "Total");
  if (property === 'checkLogNum') {
    return `${displayedRows1.length} Checks`;
  }
  const total = displayedRows1.reduce((acc, obj) => {
    const value = obj[property];
    return acc + (value != null ? parseFloat(value) : 0);
  }, 0);
  return total.toFixed(2);
};


  const createData1 = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        action: '',
        ura: '',
        labeler_name: 'Grand Total:',
        jcodereimb_amt: sum1('jcodereimb_amt'),
        inv_amt: sum1('inv_amt'),
        paid_amt: sum1('paid_amt'),
      });
    }
    return result;
  };

  const pinnedBottomRowData1 = useMemo(() => {
    return createData1(1, 'Bottom');
  }, [rowData2, filteredRows1]);

  // filter the data from row
  const onFilterChanged1 = (rowData2, type) => {
    const updatedRowData = rowData2.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow1(updatedRowData);
  };

  // Go to Claims redirection API call
  const handleGotoClaims = async (data, key) => {
    setErrorMessages([]);
    dispatch(getClaimTableInfo(true));
    dispatch(
      navigateToClaim(
        {
          rebateProgramCd: rebateProgrameName?.rebateProgramCd,
          rebateProgramCdAll: 0,
          paidQtr: data.paid_qtr,
          searchByNdc: true,
          client: null,
          group: null,
          claimCategoryCd: null,
          plan: null,
          userID: logInUser,
          // functionCode: 'Claim',
          // eventInquryKeyVO: [
          //   {
          //     keyType: 'NDC',
          //     key: `${claimPageDetails?.inputList?.labelerCode}-${claimPageDetails?.inputList?.productCode}-${claimPageDetails?.inputList?.packageSize}`,
          //   },
          // ],
          drugSqnNum: [data?.drugseqnum],
        },
        () => {
          redirectURLLink(
            '/selected-claim',
            'Selected Claim',
            history,
            dispatch
          );
          // navigateToPage('/selected-claim', 'Selected Claim');
        }
      )
    );
  };
  // Go to Display unit conversion screen
  // handing Unit conversion page redirect
  const handleViewDetailsForUnitConversion = async (data) => {
    setErrorMessages([]);
    dispatch(
      getUnitConversionDetail({
        drugSeqNum: [data?.drugseqnum],
      })
    );
    const result = await dispatch(
      getNdcGrid({
        drugSeqNum: data?.drugseqnum,
      })
    );
    if (result.payLoad && result.payLoad?.length > 0) {
      redirectURLLink(
        '/unitConversion-detail',
        'Display Unit Conversion for NDC',
        history,
        dispatch
      );
    } else {
      handleScrollToEvent();
      setErrorMessages([MNFC_NDC_ERROR_MSG]);
      // await Promise.resolve();
      // setErrorMessages([]);
      // setTimeout(() => {
      //   setErrorMessages([]);
      // }, 5000);
    }
  };

  // Function to add total rows, sort by labeler_code, and sort by paid_qtr within each group
  const addTotalRow = (groupedData) => {
    const dataWithTotal = [];

    // Convert the groupedData object to an array for sorting by labeler_code
    const sortedGroups = Object.entries(groupedData).sort(
      ([keyA], [keyB]) => (Number(keyA) || 0) - (Number(keyB) || 0)
    );

    // Process each group
    for (const [labeler_code, oneMfgData] of sortedGroups) {
      // Sort items within the group by paid_qtr
      oneMfgData.sort((a, b) => (a.paid_qtr || 0) - (b.paid_qtr || 0));

      const totalRow = {};

      for (let i = 0; i < oneMfgData.length; i++) {
        const mod = { ...oneMfgData[i] };
        if (i !== 0) {
          mod.labeler_code = ''; // Clear labeler_code for total row
        }
        dataWithTotal.push(mod);
        

        if (totalRow.labeler_name) {
          totalRow.jcodereimb_amt += oneMfgData[i].jcodereimb_amt || 0;
          totalRow.inv_amt += oneMfgData[i].inv_amt || 0;
          totalRow.paid_amt += oneMfgData[i].paid_amt || 0;
        } else {
          totalRow.labeler_name = 'Total';
          totalRow.jcodereimb_amt = oneMfgData[i].jcodereimb_amt || 0;
          totalRow.inv_amt = oneMfgData[i].inv_amt || 0;
          totalRow.paid_amt = oneMfgData[i].paid_amt || 0;
        }
      }
      dataWithTotal.push(totalRow);
    }

    return dataWithTotal;
  };

  React.useEffect(() => {
    const processData = () => {
      let data;
      if (getSortBy === 'Manufacturer') {
        data = resultSummaryMfgList;
      } else {
        data = resultSummaryQtrList;
      }

      if (Array.isArray(data) && data.length > 0) {
        if (getSelectedOptionList === 'Summary') {
          // Convert labeler_code to number for sorting
          const dataWithSortingCode = data.map((item) => ({
            ...item,
            numeric_labeler_code: Number(item.labeler_code),
          }));

          // Sort numerically by numeric_labeler_code
          dataWithSortingCode.sort(
            (a, b) => a.numeric_labeler_code - b.numeric_labeler_code
          );

          // Remove the numeric_labeler_code field after sorting
          data = dataWithSortingCode.map((item) => {
            const { numeric_labeler_code, ...rest } = item;
            return rest;
          });

          // Group the sorted data by labeler_code
          const groupedData = groupBy(data, 'labeler_code');
          data = addTotalRow(groupedData); // Add totals and sort final data
        }
        // Format the data
        data = data?.map((item) => {
          return {
            ...item,
            jcodereimb_amt: parseFloat(item?.jcodereimb_amt || 0).toFixed(2),
            inv_amt: parseFloat(item?.inv_amt || 0).toFixed(2),
            paid_amt: parseFloat(item?.paid_amt || 0).toFixed(2),
          };
        });
      } else {
        data = []; // Handle empty or undefined data
      }
      const newData=data.filter(row => row.labeler_name !== "Total");
      if (getSortBy === 'Manufacturer') {
        setSummaryMfgList(newData);
      } else {
        setSummaryQtrList(data);
      }
    };

    processData();
  }, [resultSummaryMfgList, resultSummaryQtrList, getSelectedOptionList]);

  const exportAllTpPDF = async (name, type) => {
    setExportFileName(name || '');
    setExportAllClicked(type !== 'excel');
    let newObj = [];
    if (!exportAllData?.length > 0) {
      if (getSelectedOptionList === 'Detail' && getSortBy === 'Quarter') {
        newObj = await dispatch(
          getExportToAllData(
            {
              asRpc: rebateProgramName,
              asStartQtr: newStartQtr,
              asEndQtr: newEndQtr || nCurQtr,
              asMfg: manufactureID?.map((item) => item?.manufacturerID),
              // an_all: getIsAllMfg == true ? 1 : 0,
              an_all: 0,
              an_allclaim: 1,
            },
            getSortBy
          )
        );
      } else if (getSelectedOptionList === 'Detail' && getSortBy === 'NDC') {
        newObj = await dispatch(
          getExportToAllData(
            {
              asRpc: rebateProgramName,
              asStartQtr: newStartQtr,
              asEndQtr: newEndQtr || nCurQtr,
              asMfg: manufactureID?.map((item) => item?.manufacturerID),
              // an_all: getIsAllMfg == true ? 1 : 0,
              an_all: 0,
              an_allclaim: 1,
            },
            getSortBy
          )
        );
      }
    } else {
      const tempObj = [...exportAllData];
      newObj = tempObj;
      dispatch(setExportToAllData([]));
      // setTimeout(() => dispatch(setExportToAllData(tempObj)), 100);
      await Promise.resolve();
      dispatch(setExportToAllData(tempObj));
    }
    return newObj;
  };
  const calculateSum = (property, rowData) => {
    const displayedRows1 = rowData?.filter((x) => {
      return !x.isBottomRow;
    });
    const data = displayedRows1?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };
  const getDataForExport = (resultList) => {
    let tempObj = [];
    if (resultList?.length > 0) {
      manufactureID.forEach((item) => {
        const groupByMfgId = resultList
          ?.filter((x) => {
            return x.labeler_code === item.manufacturerID;
          })
          ?.map((prop) => {
            return {
              ...prop,
              ndc: `${prop.labeler_code}-${prop.product_code}-${prop.package_size}`,
              inv_amt:
                parseFloat(prop.ura || 0) * parseFloat(prop.jcode_units || 0),
            };
          })
          ?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1));
        const formattedDataOfoneGroup = resultList
          ?.filter((x) => {
            return x.labeler_code === item.manufacturerID;
          })
          ?.map((prop) => {
            const percent_medical =
              prop?.total_units === 0
                ? 0
                : 100 * (Number(prop.jcode_units) / Number(prop.total_units));

            const newQtr = `${prop?.paid_qtr?.substring(
              4,
              5
            )}Q${prop?.paid_qtr?.substring(0, 4)}`;
            const newInvAmt =
              parseFloat(prop.ura || 0) * parseFloat(prop.jcode_units || 0);

            return {
              'Manufacturer ID': item?.manufacturerID,
              'Manufacturer Name': item.manufacturerName,
              NDC: `${prop.labeler_code}-${prop.product_code}-${prop.package_size}`,
              'Drug Name': prop.drug_name,
              Qtr: newQtr,
              'HCPCS Code': prop.jcode,
              URA: `${parseFloat(prop.ura || 0).toFixed(4)}~=~right`,
              'Medical Claim Units': `${parseFloat(
                prop.jcode_units || 0
              ).toFixed(4)}~=~right`,
              'Percent Medical': `${parseFloat(percent_medical || 0)?.toFixed(
                2
              )} %`,
              'Reimbursed Amt': `$ ${parseFloat(
                prop.jcodereimb_amt || 0
              )?.toFixed(2)}`,
              'Invoiced Amt': `$ ${parseFloat(newInvAmt)?.toFixed(2)}`,
              'Paid Amt': `$ ${parseFloat(prop.total_paid_amt || 0)?.toFixed(
                2
              )}`,
            };
          })
          ?.sort((a, b) => (a.NDC > b.NDC ? 1 : -1));
        formattedDataOfoneGroup.push({
          'Manufacturer ID': '',
          'Manufacturer Name': '',
          NDC: '',
          'Drug Name': '',
          Qtr: '',
          'HCPCS Code': '',
          URA: '',
          'Medical Claim Units': 'Grand Total:',
          'Percent Medical': '',
          'Reimbursed Amt': `$ ${calculateSum('jcodereimb_amt', groupByMfgId)}`,
          'Invoiced Amt': `$ ${calculateSum('inv_amt', groupByMfgId)}`,
          'Paid Amt': `$ ${calculateSum('total_paid_amt', groupByMfgId)}`,
        });
        tempObj = [...tempObj, ...formattedDataOfoneGroup];
      });
    }
    return tempObj;
  };
  const exportAllToXlsx = async () => {
    const resultList = await exportAllTpPDF('', 'excel');
    setExportAllClicked(false);
    const jsonData = await getDataForExport(resultList);
    return {
      jsonData,
      boldRows: [1],
    };
  };
  React.useEffect(() => {
    if (exportAllClicked && exportAllData?.length > 0) {
      const datForExportAll = {};
      manufactureID.forEach((item) => {
        const formattedDataOfoneGroup = JSON.parse(
          JSON.stringify(
            exportAllData
              ?.filter((x) => {
                return x.labeler_code === item.manufacturerID;
              })
              ?.map((prop) => {
                const percent_medical =
                  prop?.total_units === 0
                    ? 0
                    : 100 *
                      (Number(prop.jcode_units) / Number(prop.total_units));

                const newQtr = `${prop?.paid_qtr?.substring(
                  4,
                  5
                )}Q${prop?.paid_qtr?.substring(0, 4)}`;
                const newInvAmt =
                  parseFloat(prop.ura || 0) * parseFloat(prop.jcode_units || 0);

                return {
                  ...prop,
                  ura: prop.ura ? prop.ura.toFixed(4) : '0.0000',
                  ndc: `${prop.labeler_code}-${prop.product_code}-${prop.package_size}`,
                  jcode_units: Number(prop.jcode_units).toFixed(4),
                  paid_qtr: newQtr,
                  percent_medical: parseFloat(percent_medical)?.toFixed(2),
                  inv_amt: newInvAmt?.toFixed(2),
                };
              })
              ?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1))
          )
        );
        formattedDataOfoneGroup.push({
          isBottomRow: true,
          action: '',
          ura: '',
          jcode_units: 'Grand Total:',
          percent_medical: '',
          jcodereimb_amt: calculateSum(
            'jcodereimb_amt',
            formattedDataOfoneGroup
          ),
          inv_amt: calculateSum('inv_amt', formattedDataOfoneGroup),
          total_paid_amt: calculateSum(
            'total_paid_amt',
            formattedDataOfoneGroup
          ),
        });
        datForExportAll[item.manufacturerID] = formattedDataOfoneGroup;
      });
      setExportAllClicked(false);
      if (Object.values(datForExportAll)[0].length > 0) {
        exportAllPDF(
          datForExportAll,
          userDefaults,
          {
            info: {
              firstInfo: 'Manufacturer ID :',
              secondInfo: 'Name: ',
              fifthInfo: `${rebateProgramNameValue}`,
              thirdInfo: `Report: ${getSelectedOptionList}`,
              fourthInfo: `SortBy : ${getSortBy}`,
              sixthInfo: `Quarter Range:${`${startQtrValue}-${
                endQtrValue || curQtr
              }`}`,
            },
            manufactureID,
            pageSize: {
              height: 700,
              width: 1000,
            },
            reportName: 'HCPCS Code Claims Paid Report',
            fileName: exportFileName || 'HCPCSCodeClaimsPaid',
          },
          dispatch,
          logInUser,
          columnApi
        );
      }
    }
  }, [exportAllData]);

  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  let fifthInfo = '';
  firstInfo = `Manufacturer ID : ${manufacturer}`;
  secondInfo = `Name: ${manufactureID?.[count - 1]?.manufacturerName}`;
  fifthInfo = `${rebateProgramNameValue}`;
  thirdInfo = `Report: ${getSelectedOptionList}`;
  fourthInfo = `SortBy : ${getSortBy}`;
  const sixthInfo = `Quarter Range:${`${startQtrValue}-${
    endQtrValue || curQtr
  }`}`;

  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Display HCPCS Code Claims Paid"
      />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Quarter "
                          id="Quarter"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={`${startQtrValue}-${endQtrValue || curQtr}`}
                        />
                      </div>
                    </div>

                    <div className="row mb-2">
                      {getSelectedOptionList === 'Summary' ? (
                        !(
                          <div className="col-6">
                            <TextField
                              label="Manufacturer ID "
                              id="Manufacturer ID"
                              fullWidth
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled
                              value={[manufacturer]}
                            />
                          </div>
                        )
                      ) : (
                        <div className="col-6">
                          <TextField
                            label="Manufacturer ID "
                            id="Mannufacturer ID"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled
                            value={[manufacturer]}
                          />
                        </div>
                      )}

                      <div className="col-6">
                        <TextField
                          label="Report Type "
                          id="Report Type"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={getSelectedOptionList}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      {getSelectedOptionList === 'Summary' ? (
                        !(
                          <div className="col-6">
                            <TextField
                              label="Name"
                              id="Name"
                              fullWidth
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled
                              value={
                                manufactureID?.[count - 1]?.manufacturerName
                              }
                            />
                          </div>
                        )
                      ) : (
                        <div className="col-6">
                          <TextField
                            label="Name"
                            id="Name"
                            fullWidth
                            disabled
                            value={manufactureID?.[count - 1]?.manufacturerName}
                          />
                        </div>
                      )}
                      <div className="col-6">
                        <TextField
                          label="Sorted By "
                          id="Sorted By"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={getSortBy}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="clearfix">
          {getSelectedOptionList === 'Detail' && (
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner"
            >
              <TableGrid
                ref={gridRef}
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={
                  fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
                }
                isScrollOn
                rowData={rowData1
                  ?.map((item) => {
                    return {
                      ...item,
                      ura: item.ura ? item.ura.toFixed(4) : '0.0000',
                      ndc: `${item.labeler_code}-${item.product_code}-${item.package_size}`,
                      jcode_units: Number(item.jcode_units).toFixed(4),
                    };
                  })
                  ?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1))}
                exportAllTpPDF={
                  manufactureID?.length > 1 ? exportAllTpPDF : null
                }
                exportAllToXlsx={
                  manufactureID?.length > 1 ? exportAllToXlsx : null
                }
                columnDefs={detailReportTypeTableGrid}
                noGlobalSort
                exportFile
                animateRows
                sideBar={false}
                fileName="HCPCSCodeClaimsPaid"
                reportName="HCPCS Code Claims Paid Report"
                gridCall={onGridReady}
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onFilterData={onFilterChanged}
                countValue={count}
                onCellFocused={onCellFocused}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    if (cellInfo.data.isBottomRow) {
                      return null;
                    }
                    return (
                      <div className="tdCell icon-btn-group">
                        <Dropdown className="icon-dropdown-container ml-2">
                          <Dropdown.Toggle
                            className="icon-dropdown"
                            aria-label="Export"
                          >
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="action-tooltip">Action</Tooltip>
                              }
                            >
                              <SVGComponent iconName="Icon-export1" />
                            </OverlayTrigger>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="export_dropdown h-auto">
                            <Dropdown.Item
                              role="button"
                              onClick={() => {
                                handleGotoClaims(cellInfo.data);
                              }}
                            >
                              {' '}
                              Go to Claims
                            </Dropdown.Item>
                            <Dropdown.Item
                              role="button"
                              onClick={() => {
                                handleViewDetailsForUnitConversion(
                                  cellInfo.data
                                );
                              }}
                            >
                              {' '}
                              Go to Maintain Unit Conversion
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  },
                  TotalUnitsCellRender: (cellInfo) => {
                    const isNegativeVal = !(
                      parseFloat(cellInfo?.data?.total_units) >= 0
                    );
                    return (
                      <>
                        {cellInfo?.data?.isBottomRow ? (
                          <span className="semiBoldText">Grand Total:</span>
                        ) : isNegativeVal ? (
                          <div
                            style={{ color: '#eb0000' }}
                          >{`(${cellInfo?.data?.jcode_units
                            ?.toString()
                            ?.replace('-', '')
                            .trim()})`}</div>
                        ) : (
                          <div>{`${cellInfo?.data?.jcode_units}`}</div>
                        )}
                      </>
                    );
                  },
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return (
                      <div
                        className={
                          cellInfo.data?.isBottomRow ? 'semiBoldText' : ''
                        }
                      >
                        {name}
                      </div>
                    );
                  },
                }}
                // hideColumnsInPdf={true}
                pinnedBottomRowData={pinnedBottomRowData}
                // handleViewHistory
                info={{
                  firstInfo,
                  secondInfo,
                  fifthInfo,
                  thirdInfo,
                  fourthInfo,
                  sixthInfo,
                }}
                getFilterApply={getFilterApply}
              />
            </div>
          )}
        </div>
        {getSelectedOptionList === 'Summary' && (
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
          >
            <TableGrid
              ref={gridRef}
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={
                fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
              }
              isScrollOn
              defaultColWidth={200}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              noGlobalSort
              rowData={rowData2?.map((item) => {
                return {
                  ...item,
                  ura: item.ura ? item.ura.toFixed(4) : '0.0000',
                };
              })}
              columnDefs={
                getSortBy == 'Manufacturer'
                  ? summaryReportTypeTableGridWithOutQtr
                  : summaryReportTypeTableGrid
              }
              exportFile
              animateRows
              sideBar={false}
              fileName="HCPCSCodeClaimsPaid"
              reportName="HCPCS Code Claims Paid Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onFilterData={onFilterChanged1}
              onCellFocused={onCellFocused}
              pinnedBottomRowData={pinnedBottomRowData1}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              info={{
                firstInfo,
                secondInfo,
                fifthInfo,
                thirdInfo,
                fourthInfo,
                sixthInfo,
              }}
              getFilterApply={getFilterApply}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayHcpcsCode;
